module.exports = __webpack_public_path__ + "img/my-transactions.481bbb4f.svg";